/**
 * High-performance opened trades hooks with minimal re-renders
 */

import { useOpenedTradesStore } from '../stores/useOpenedTradesStore';

// Main hook with individual selectors to avoid re-renders
export const useOpenedTrades = () => {
  const allTrades = useOpenedTradesStore((state) => state.allTrades);
  const loadingStatus = useOpenedTradesStore((state) => state.loadingStatus);
  const errorMessage = useOpenedTradesStore((state) => state.errorMessage);
  const totalCount = useOpenedTradesStore((state) => state.totalCount);
  const lastUpdated = useOpenedTradesStore((state) => state.lastUpdated);
  const getTradeByTicket = useOpenedTradesStore((state) => state.getTradeByTicket);
  const getTradesBySymbol = useOpenedTradesStore((state) => state.getTradesBySymbol);

  return {
    allTrades,
    loadingStatus,
    errorMessage,
    totalCount,
    lastUpdated,
    isComplete: loadingStatus === 'complete',
    hasTrades: allTrades.length > 0,
    getTradeByTicket,
    getTradesBySymbol,
  };
};

// Loading status only (minimal re-renders)
export const useOpenedTradesLoading = () => {
  const status = useOpenedTradesStore((state) => state.loadingStatus);
  const errorMessage = useOpenedTradesStore((state) => state.errorMessage);
  
  return { status, errorMessage };
};

// Individual trade lookup (no re-renders on data changes)
export const useOpenedTrade = (ticket: number) => {
  const getTradeByTicket = useOpenedTradesStore((state) => state.getTradeByTicket);
  return getTradeByTicket(ticket);
};
